import { useNavigate } from "react-router-dom";
import { authAPI } from "../../../services/api";
import BackButton from "./BackButton";

function UserManagementPage() {
  const navigate = useNavigate();
  const currentUser = authAPI.getCurrentUser();

  if (!currentUser || (currentUser.userId !== 1 && currentUser.userName?.toLowerCase() !== "admin")) {
    return (
      <div className="settings-page">
        <header className="settings-page-header">
          <BackButton to="/settings" section="users" />
          <h1 className="settings-page-title">User Management</h1>
        </header>
        <main className="settings-page-content">
          <div className="settings-empty-state">
            <i className="fas fa-lock" />
            <p>Access denied. Admin privileges required.</p>
          </div>
        </main>
      </div>
    );
  }

  const handleNavigate = () => {
    navigate("/admin/users");
  };

  return (
    <div className="settings-page">
      <header className="settings-page-header">
        <BackButton to="/settings" section="users" />
        <h1 className="settings-page-title">User Management</h1>
      </header>

      <main className="settings-page-content">
        <div className="settings-form-card">
          <div className="settings-form-body">
            <div className="settings-feature-grid">
              <div className="settings-feature-item">
                <i className="fas fa-check-circle text-green-500" />
                <span>View all users</span>
              </div>
              <div className="settings-feature-item">
                <i className="fas fa-check-circle text-green-500" />
                <span>Activate/Deactivate users</span>
              </div>
              <div className="settings-feature-item">
                <i className="fas fa-check-circle text-green-500" />
                <span>Reset user passwords</span>
              </div>
              <div className="settings-feature-item">
                <i className="fas fa-check-circle text-green-500" />
                <span>Manage subscriptions</span>
              </div>
            </div>

            <div className="settings-form-actions">
              <button
                type="button"
                onClick={handleNavigate}
                className="settings-form-btn"
              >
                <i className="fas fa-users-cog" />
                <span>Open User Management Panel</span>
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default UserManagementPage;
